export default __webpack_public_path__ + "static/media/moms6.20d6a19c.jpeg";